/*
 * @Author: huangyan
 * @Date: 2021-08-09 10:18:31
 * @Description:
 */
import request from '@/utils/request'

 /**
 * 根据id获取地址信息
 * @param {{ codes: '省市区code拼接字符串' }} params -请求参数
 * @returns {Promise}
 */
export const fetchAddressByCodes = (params) => request.get('/common/sysAddress/getPCDAddress', {params})

   /**
 * 上传图片
 * @param {object} data -请求参数
 */
export const fetchUploadImg = (data) => request.post('/common/upload/uploadImg', data, {
	headers: { "Content-Type": "multipart/form-data" }
})

/**
 * 上传视频
 * @param {object} data
 * @returns
 */
export const fetchUploadVideo = (data) => request.post('/common/upload/uploadVideo', data, {
	headers: { "Content-Type": "multipart/form-data" }
})

/**
 * 获取所有品牌
 * @returns
 */
export const fetchBrandAll = (data) => request.get('/common/featureLabel/getBrandLableAll', { params: data })

/**
 * 获取应用类型
 * @returns
 */
export const fetchCatalogueList = () => request.post('/common/featureLabel/list?parentId=1&pageNumber=1&pageSize=99')

/**
 * 获取文章列表
 * @param {object} data
 * @returns
 */
export const fetchMaterialList = (data) => request.post('/cms/feature/featureArticle/materialList', data)

/**
 * 获取小程序码
 * @param {object} params
 * @returns
 */
export const fetchWxCode = (params) => request.get('/wap/getQrcode', {params: params})

/**
 * 商品列表
 * @param {object} data
 * @returns
 */
export const fetchGoodsList = (data) => request.get('/common/goods/list2', {params: data})

/**
 * 尚品会员卡类型列表
 * @param {{ type?: string, enable?: string, is_first_discounts?: string  }} params
 * @returns
 */
export const fetchVipCardList = (params) => request.get('/common/vipCard/vipCardTemplateList', { params })

/**
 * 尚品会员卡购买
 * @param {object} params
 * @returns
 */
export const fetchVipCardBuy = (data) => request.post('/common/vipCard/payVipCard', data)

/**
 * 尚品会员卡购买记录
 * @param {object} params
 * @returns
 */
export const fetchVipCardBuyLogs = (params) => request.get('/common/vipCard/queryVipCardLog', {params})

/**
 * 根据code获取商品
 * @param {object} params
 * @returns
 */
 export const fetchGoodsByCode = (params) => request.get('/wap/goods/getByCode?' + params.goodsCode)

 /**
 * 尚品会员文案配置获取
 * @param {object} params
 * @returns
 */
export const fetchVipTipsGet = (params = {}) => request.get('/common/vipCard/getVipEditorInfo', {params})

/**
 * 充值帮助入口名称
 * @param {object} params
 * @returns
 */
export const fetchRechargeBtnNameGet = (params = {}) => request.get('/recharge/help/entry/name', {params})

/**
 * 获取商城公告列表
 * @param {object} data
 * @returns {promise}
 */
 export const fetchNoticeList = (params) => request.get('/cms/bulletin/list', {params})

 /**
  * 获取商城公告未读数
  * @param {object} data
  * @param {object} config -配置信息
  * @returns {promise}
  */
 export const fetchNoticeUnRead = (params) => request.get('/cms/bulletin/count', {params})

 /**
  * 获取商城公告详情
  * @param {{ bulletinId: number }} params
  * @returns {promise}
  */
 export const fetchNoticeGet = (params) => request.get('/cms/bulletin/info', {params})

/**
 * 校验营业执照
 * @param {object} params
 * @returns
 */
export const licenseVerify = (data) => request.post('/common/customerData/self/license/verify', data)

/**
 * 注册提示文案
 * @param {object} params
 * @returns
 */
export const registerTips = (params = {}) => request.get('/common/customerData/self/license/register/tips', {params})

/**
 * 校验营业执照后注册
 * @param {object} params
 * @returns
 */
export const licenseRegister = (data) => request.post('/common/customerData/self/license/register', data)

/**
 * 获取快递公司列表
 * @param {object} params
 * @returns
 */
export const fetchExpressList = (params) => request.get('/common/express/expressAll', {params})


/**
  * 获取配赠账户列表
  * @param {object} params
  * @returns
  */
export const getUserTransformAccount = (params) => request.get('/common/franchisee/getUserTransformAccount', {params})

 /**
   * 配赠账户余额查询
   * @param {object} params
   * @returns
   */
export const getGiveCatalog = (params) => request.get('/common/franchisee/getGiveCatalog', {params})

/**
   * 转换账户资金
   * @param {object} params
   * @returns
   */
export const transformAccount = (data) => request.post('/common/franchisee/transformAccount', data)



/**
 * 获取系统参数
 * @param {object} params
 * @returns
 */
export const getSonList = (params) => request.get('/common/sysSet/getSonList', {params})
